import React from 'react';
import { View, Text } from 'react-native';
import styled from 'styled-components/native';
import {
  WorkoutContainerText,
} from '../styles/common-styles.js';
import { useWindowDimensions } from '../hooks/useWindowDimensions.js';

function ScoreBar({score}) {

    //////console.log("ScoreBar render");

    const { width } = useWindowDimensions();

    var scoreBarWidth = (score / 800) * 100;
    var scoreBarColor;

    if (scoreBarWidth <= 33) {
        scoreBarColor = '#FF5279';
    } else if (scoreBarWidth <= 66) {
        scoreBarColor = '#FFCB39';
    } else {
        scoreBarColor = '#87CDB3';
    }

    return (
        <ScoreBarParent screenWidth={width}>
            <ScoreBarText>{score}</ScoreBarText>
            <ScoreBarFill width={scoreBarWidth} color={scoreBarColor}></ScoreBarFill>
        </ScoreBarParent>  
    ); 
}

export const ScoreBarParent = styled.View`
    width: ${(props) => (props.screenWidth * 0.30)}px;
    max-width:135px;
    min-width:50px;
    height:25px;
    border-radius:50px;
    display:flex;
    justify-content:center;
    align-items:flex-start;
    overflow:hidden;
    border:1px solid lightgray;
`;

export const ScoreBarText = styled(WorkoutContainerText)`
    color:#282F63;
    font-size:16px;
    font-weight:700;
    margin-left:12.5px; 
    z-index:999;
`;

export const ScoreBarFill = styled.View`
    position:absolute;
    left:0;
    top:0;
    bottom:0;
    width: ${(props) => (props.width)}%;
    background:${(props) => (props.color)};
    transition: all 5s linear;
`;

export default ScoreBar;
